// import React from 'react';
// import { Link } from 'react-router';


// const HomeCard = ({name, image, category, price, loading, id}) => {
//   return (
//     <div className='bg-white shadow-md p-2 rounded min-w-[150px]'>
//         {
//             name ? (
//                 <>
//                 <Link to={`/menu/${id}`} onClick={()=>window.scrollTo({top:0, behavior: "smooth"})}>
//                     <div className='w-40 min-h-[150px]'>
//                         <img src={image} className='h-full w-full' alt='images'/>
//                     </div>
//                     <h3 className='font-semibold text-slate-600 text-center capitalize text-lg'>{name}</h3>
//                     <p className='text-center text-slate-500 font-medium'>{category}</p>
//                     <p className= 'text-center font-bold'><span className='text-red-500'>₹</span><span>{price}</span></p>
//                 </Link>
//                 </>
//             )

//             :
//             (
//                 <div className=' min-h-[150px] flex justify-center items-center w-full'>
//                     <p>{loading}</p>
//                 </div>
//             )
//         }
//     </div>
//   )
// }

// export default HomeCard



import React from 'react';
import { Link } from 'react-router';

// ── Skeleton ──────────────────────────────────────────────────────────────────
function HomeSkeleton() {
  return (
    <div
      className="rounded-2xl overflow-hidden"
      style={{ background: 'var(--bg-raised)', border: '1px solid var(--glass-border)' }}
    >
      <div className="skeleton" style={{ height: 150, borderRadius: 0 }} />
      <div className="p-3 space-y-2">
        <div className="skeleton h-3 w-14 rounded" />
        <div className="skeleton h-4 w-full rounded" />
        <div className="skeleton h-4 w-1/2 rounded" />
      </div>
    </div>
  );
}

// ── Main ──────────────────────────────────────────────────────────────────────
export default function HomeCard({ name, image, category, price, loading, id }) {
  if (!name) return <HomeSkeleton />;

  return (
    <Link
      to={`/menu/${id}`}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="glass-card card-electric rounded-2xl overflow-hidden group block animate-fade-up"
    >
      {/* Category chip */}
      <div className="relative overflow-hidden" style={{ background: 'var(--bg-surface)' }}>
        <div
          className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
          style={{
            background: 'radial-gradient(circle at 50% 80%, rgba(99,102,241,0.10) 0%, transparent 70%)',
          }}
        />
        <div className="absolute top-3 left-3 z-10">
          <span className="badge" style={{ fontSize: '0.55rem' }}>{category}</span>
        </div>
        <img
          src={image}
          alt={name}
          className="
            w-full object-contain p-4
            group-hover:scale-105 transition-transform duration-500
          "
          style={{ height: 150 }}
        />
      </div>

      <div className="p-4 pt-3">
        <h3
          className="
            text-sm font-semibold capitalize truncate mb-1
            group-hover:text-gradient transition-all duration-300
          "
          style={{ color: 'var(--text-primary)' }}
        >
          {name}
        </h3>
        <p className="font-display text-base font-bold">
          <span style={{ color: 'var(--coral)' }}>₹</span>
          <span className="text-gradient">{price}</span>
        </p>
      </div>
    </Link>
  );
}
